<template>
  <div id="app" :class="this.$route.name">
    <div class="load"><img class="wobble animated" src="./assets/images/villavela.svg" alt="Vilavella Hotel Boutique"></div>
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  metaInfo:{
    title: 'Villavela Hotel Boutique en acajutla El Salvador | Reserva Ahora',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Villavela es parte importante de la historia del Restaurante Acajutla ya que es allí donde comenzó todo hace mas de 30 años.'
      },
      {
        name: 'robots',
        content: 'index, follow'
      }
    ]
  },
  mounted() {
    setTimeout(function(){
      $('.load').addClass('fadeOut animated');
      setTimeout(() => {
        $('.load').remove();
      }, 1000);
      // $('.temp').remove();
    }, 3000);
  },
}
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i|Rozha+One')
*
  focus: none
  outline: none
  box-sizing: border-box

h1,h2,h3,h4,h5,h6,p,label,a, ul, li
  font-family: 'Open Sans', sans-serif
  font-weight: 300
  font-size: 1.2vw
  line-height: 1.7vw
  letter-spacing: 0.16vw

$primary: #074866
$secundary: #999999
$third: #CCCCCC

html, body
  display: block
  width: 100%
  overflow-x: hidden

::selection 
	background-color: $secundary
	color: #FFFFFF

.temp
  color: #FFFFFF

.load
  background: #FFFFFF
  position: fixed
  top: 0px
  left: 0px
  width: 100%
  height: 100vh
  z-index: 12
  text-align: center
  img
    width: 150px
    position: relative
    top: 45%
    margin-top: -75px
    &.animated
      -webkit-animation-duration: 10s
      animation-duration: 10s
  .copyright
    position: absolute
    bottom: 1vw
    text-align: center
    color: $primary
    font-size: 12px
    width: 100%
    a, h4
      color: $primary
      font-size: 12px
      font-weight: 500

.hidden
  display: none !important

.easeOutCubic 
  transition: all 600ms cubic-bezier(0.215, 0.61, 0.355, 1) !important
  -webkit-transition: all 600ms cubic-bezier(0.215, 0.61, 0.355, 0.9) !important
  -webkit-animation-duration: 600ms !important
  animation-duration: 600ms !important

#rotating
  -webkit-animation: rotation 2s infinite linear

@-webkit-keyframes rotation
  from
    -webkit-transform: rotate(0deg)
  to
    -webkit-transform: rotate(359deg)
  
body
  background: #FFFFFF

header
  display: block
  margin: 10px auto
  width: 100%
  position: absolute
  z-index: 11
  .ico
    display: none
    vertical-align: top
    width: 30%
    h4
      display: none
      font-size: 16px
      letter-spacing: 3px
      color: #FFFFFF
      font-weight: 100
      &.on
        display: block
  .logo
    display: inline-block
    vertical-align: top
    width: 200px
    margin-left: 4vw
    a
      display: block
      img
        width: 100%
  .nav
    display: inline-block
    vertical-align: top
    margin-top: 40px
    margin-left: 4vw
    a
      display: inline-block
      color: #FFFFFF
      font-size: 16px
      line-height: 26px
      letter-spacing: 0.2vw
      font-weight: 300
      text-transform: uppercase
      text-decoration: none
      margin: 0px 2vw
      &.router-link-exact-active  
        font-weight: 600
        color: $third
      &:hover
        color: $third
        &:after
          content: ""
          display: block
          width: 100%
          height: 0.8vw
          background: url(./assets/images/wave.png)no-repeat 0% 50% /contain
          margin-top: 0px
      &:last-child
        margin: 0px !important
        margin-left: 1vw !important
  .social-media
      display: block
      position: absolute
      right: 5%
      top: 40px
      a
        margin: 0px 5px
        color: #FFFFFF
        font-size:  18px
        padding: 10px
        opacity: 0.7
        span
          color: $secundary
          display: none
          &.on
            display: inline-block
            margin-left: 10px
            font-weight: 400
            color: $secundary
        &:hover
          color: $primary
          opacity: 1
          span
            color: $primary



footer
  position: relative
  z-index: 11
  height: 100vh
  width: 100%
  .information
    display: inline-block
    vertical-align: top
    width: 65%
    height: 100%
    .text
      padding: 0px 6vw
      position: relative
      top: 50%
      transform: translateY(-52%)
      img
        width: 190px

      h2
        font-size: 2vw
        color: $primary
        text-transform: uppercase
        margin: 0px
        font-weight: 700
        margin-top: 6vh
      a
        display: inline-block
        vertical-align: top
        font-size: 1.2vw
        line-height: 1.5vw
        color: $secundary
        text-decoration: none
        margin-top: 4vh
        padding-left: 2vw
        &:after
          content: ""
          display: block
          width: 100%
          height: 0.8vw
          background: url(./assets/images/wave.png)no-repeat 0% 50% /contain
          margin-top: 10px
        &:nth-child(3)
          padding-left: 0%
          width: 20vw
          text-align: left
    .form
      display: block
      margin-top: 4vh
      form
        display: block
        width: 50vw
        input
          display: block
          width: 100%
          border: none
          border-bottom: 1px solid $third
          padding: 10px 0px
          margin-top: 3vh
          font-size: 16px
          line-height: 26px
          &::placeholder
            color: $third
          &:-ms-input-placeholder
            color: $third
          &::-ms-input-placeholder
            color: $third
          &[name="nel"]
            display: none
          &[name="email"]
            display: inline-block
            vertical-align: top
            width: 47%
          &[name="phone"]
            display: inline-block
            vertical-align: top
            width: 47%
            margin-left: 6%
        textarea
          display: block
          width: 100%
          padding: 10px 0px
          border: none
          margin-top: 3vh
          font-size: 16px
          line-height: 26px
          border-bottom: 1px solid $third
          &::placeholder
            color: $third
          &:-ms-input-placeholder
            color: $third
          &::-ms-input-placeholder
            color: $third
        button
          display: block
          background: $primary
          color: #FFFFFF
          border: none
          border-radius: 20px
          padding: 5px 0px
          margin: 2vw 0px 0px auto
          text-align: center
          width: 140px
          font-size: 16px
          line-height: 26px
          cursor: pointer
          position: relative
          i
            font-size: 0px
            font-weight: 600
            display: none
            &:last-child
              display: none
          &:hover
            background: #FFFFFF
            color: $primary
            font-weight: 700
            border-radius: 0px
            i
              display: inline
              font-size: 16px
              &:last-child
                display: none
          &.submit
            color: #FFFFFF
            background: #FFFFFF
            i
              color: #FFFFFF
              &.fa-spinner
                display: block
                color: $primary
                position: absolute
                left: 50%
                top: 50%
                font-size: 20px
                margin-top: -10px
                margin-left: -10px
    .social-media
      display: block
      position: absolute
      bottom: 30px
      left: 5%
      a
        margin: 0px 5px
        color: $secundary
        font-size:  18px
        padding: 10px
        span
          color: $secundary
          display: none
          &.on
            display: inline-block
            margin-left: 10px
          &:hover
            color: $primary
        &:hover
          color: $primary
  .background
    display: inline-block
    vertical-align: top
    width: 35%
    height: 100%
    background: url(./assets/images/villavela-hotel-boutique.png)no-repeat 50% 50% /cover
  .copyright
    position: absolute
    right: 5%
    bottom: 20px    
    h4
      color: #FFFFFF
      font-size: 10px
      line-height: 20px
      letter-spacing: 0.09vw !important
      a
        font-size: 10px
        line-height: 20px
        leter-spacing: 2px
        text-transform: uppercase
        color: #FFFFFF
    .fondepro
      text-align: right
      text-decoration: none
      img
        display: block
        margin: 0px 0px 0px auto
        width: 250px
        filter: grayscale(100%) brightness(0) invert(1)
        &:hover
          filter: none
      p
        font-size: 10px
        line-height: 20px
        leter-spacing: 2px
        margin: 0px
        text-transform: uppercase
        color: #FFFFFF

#app
  display: block
  position: relative
  section
    display: block

@media(max-width: 1024px)
  header
    display: block
    width: 100%
    z-index: 13
    .logo
      vertical-align: middle
      width: 46%
      margin-left: 0px
      text-align: center
      z-index: 4
      position: relative
      img
        max-width: 150px
        margin: auto
    .ico
      display: inline-block
      vertical-align: middle
      width: 27%
      text-align: center
      cursor: pointer
      z-index: 4
      position: relative
    .nav
      display: none
      position: fixed
      top: 0px
      left: 0px !important
      margin: 0px !important
      background: $secundary
      height: 100vh
      width: 100%
      z-index: 3
      &.on
        display: block
      div
        position: relative
        top: 45%
        transform: translateY(-50%)
      a
        font-size: 30px
        line-height: 40px
        font-weight: 100
        display: block
        text-align: center
        margin: 5vh
        &.router-link-exact-active
          color: $primary
    .social-media
      display: inline-block
      vertical-align: middle
      width: 27%
      text-align: center
      top: 3px
      right: 0px
      z-index: 4
      position: relative
      a
        display: block
        margin: 0px
        padding: 5px 0px
        i
          font-size: 16px
          margin-left: 10px
          &.fa-flag
            display: none
        span
          &.on
            display: block
            font-size: 18px
            margin-top: 10px
            font-weight: bold
            color: #FFF

  footer
    height: auto
    .copyright
      position: relative
      right: 0px
      bottom: 0px
      margin: 0px 10% 30px 10%
      h4, a
        text-align: center
        color: $primary !important
        font-size: 12px !important
        font-weight: 600
      .fondepro
        text-align: center
        img
          filter: none
          margin: auto
        p
          color: $primary
          font-weight: 600
    .information
      display: block
      width: 100%
      .social-media
        position: relative
        bottom: 0px
        left: 0px
        text-align: center
        margin: 40px 0px 30px 0px
        a
          i
            font-size: 20px
            &.fa-flag
              display: none
        span
          &.on
            display: block
            font-size: 18px
            margin-left: 0px !important
            margin-top: 10px
            font-weight: bold

      .form 
        form
          width: 100%
          margin: auto
          input
            width: 100% !important
            display: block
            margin-left: 0% !important
            color: $secundary
          button
            margin: 40px auto 0px auto
            i
              font-size: 16px !important
      .text
        top: 0%
        transform: none
        padding: 0px
        width: 80%
        margin: auto
        padding-top: 40px
        br
          display: none
        h2
          font-size: 25px
        a
          font-size: 16px
          line-height: 26px
          display: block
          width: 100%
          margin: 25px 0px
          padding: 0px
          &:after
            height: 10px
          &:nth-child(3)
            width: 100%
    .background
      display: none
  .load
    img
      width: 100px
      margin-top: -50px

</style>
